import cardComApi from "../_ApiConn/cardComApi";



const goCardCom = async (theOrder) => {
    let dFromF = await cardComApi.goCardCom(theOrder);
    return (dFromF);
}


const cardChargeToken = async (theOrder) => {
    const usrtoken = localStorage.getItem('usrtoken');

    let dFromF = await cardComApi.cardChargeToken({ ...theOrder, usrtoken });
    return (dFromF);
}


const CardComApprove = async (theOrder) => {
    let dFromF = await cardComApi.CardComApprove(theOrder);
    return (dFromF);
}
const createJ5Hold = async (theOrder) => {
    let dFromF = await cardComApi.createJ5Hold(theOrder);
    return (dFromF);
}

const chargeJ5 = async (theOrder) => {
    const usrtoken = localStorage.getItem('usrtoken');
    let dFromF = await cardComApi.chargeJ5({ ...theOrder, usrtoken });
    return (dFromF);
}


export default {
    goCardCom,
    CardComApprove,
    cardChargeToken,
      createJ5Hold,   
    chargeJ5 
};